import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { MDBModalRef, MDBModalService, ToastService } from 'ng-uikit-pro-standard';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import { selectIsAuth, selectUserInfo } from 'src/app/redirect/reducers';
import { Signin } from 'src/app/signin.interface';
import * as headerActions from '../header.actions';

@Component({
  selector: 'app-side',
  templateUrl: './side.component.html',
  styleUrls: ['./side.component.scss']
})
export class SideComponent implements OnInit, OnDestroy {

  isAuth: boolean;
  isAuth$$: Subscription;

  userInfo: Signin;

  constructor(
    private store: Store,
    private authService: AuthService,
    private router: Router) { }

  ngOnInit(): void {
    this.checkAuth();
  }

  checkAuth() {
    this.isAuth$$ =
    this.store.select(selectUserInfo)
    .subscribe(userInfo => {
      this.isAuth = !!userInfo.UUID;
      // this.isAuth = true;
      this.userInfo = userInfo as Signin;
    });
  }

  onSignin() {
    this.authService.signin();
  }

  onSignout() {
    this.store.dispatch(headerActions.signOut());
  }

  onHome() {
    this.router.navigate(['/']);
  }


  onProfile() {
    this.router.navigate(['/profile']);
  }


  onNewsroom() {
    this.router.navigate(['/newsroom']);
  }

  onReload() {
    this.router.navigate(['/reload']);
  }

  onInbox() {
    this.router.navigate(['/newsroom/inbox']);
  }

  ngOnDestroy() {
    this.isAuth$$.unsubscribe();
  }

}
